"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var COS_EMAIL_URI = 'cosemail/v1/emails';
var BLOG_URI = 'blog-settings/v1/blogs';

var BlogNotificationEmailsAPI =
/*#__PURE__*/
function () {
  function BlogNotificationEmailsAPI() {
    (0, _classCallCheck2.default)(this, BlogNotificationEmailsAPI);
  }

  (0, _createClass2.default)(BlogNotificationEmailsAPI, null, [{
    key: "getBlogNotificationEmails",
    value: function getBlogNotificationEmails(_ref) {
      var blogId = _ref.blogId;
      return _apiClient.default.get(COS_EMAIL_URI + "/blog/" + blogId, {
        query: {
          casing: 'snake'
        }
      });
    }
  }, {
    key: "getBlogNotificationEmail",
    value: function getBlogNotificationEmail(_ref2) {
      var blogId = _ref2.blogId,
          type = _ref2.type;
      return _apiClient.default.get(COS_EMAIL_URI + "/blog/" + blogId + "/" + type, {
        query: {
          casing: 'snake'
        }
      });
    }
  }, {
    key: "updateBlogNotificationEmails",
    value: function updateBlogNotificationEmails(_ref3) {
      var blogId = _ref3.blogId,
          data = _ref3.data;
      return _apiClient.default.put(BLOG_URI + "/" + blogId + "/notification-emails", {
        data: data,
        query: {
          casing: 'snake'
        }
      });
    }
  }]);
  return BlogNotificationEmailsAPI;
}();

exports.default = BlogNotificationEmailsAPI;
module.exports = exports.default;